const CHARGE_TYPE = Object.freeze({
  noShowBank: 'bank-as-no-show',
  noShowCharge: 'charge-as-no-show',
  keep: 'keep-in-user-account',
  refund: 'refund-to-client',
});

// noinspection JSUnusedGlobalSymbols
export default CHARGE_TYPE;
